module.exports = __webpack_public_path__ + "static/media/Peak-End Rule - anne-nygard-OpNMKVpZPEE-unsplash.c1f2a75d.jpg";